import { NgModule, APP_INITIALIZER, InjectionToken } from '@angular/core';
import { AppComponent } from './app.component';
// import { AdalService } from './shared/services/adal.service';
import { HeaderComponent } from './header/header.component';
import{SignOutComponent} from './signOut/signout.component'
import { SidebarComponent } from './sidebar/sidebar.component';
import { routes } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { TokenInterceptor } from './shared/token-interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridModule } from './shared/grid/grid.module';
import { SharedModule } from './shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { AuthGuard } from './shared/authentication/auth.guard';
import { AuthenticationService } from './shared/authentication/authentication.service';
import { BrowserModule } from '@angular/platform-browser';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderService } from './shared/loader/loader.service';
import { EnvService } from './shared/services/env.service';
import { HomeComponent } from './home/home.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { UserIdleModule } from 'angular-user-idle';
import { MsalModule, MsalService, MSAL_CONFIG, MSAL_CONFIG_ANGULAR} from '@azure/msal-angular';
import { Configuration, Logger, LogLevel } from "msal";
import { AppConfig } from './shared/authentication/config';


let msalConfig: any; // will be initialized by APP_INITIALIZER
export function msalConfigFactory() {
  return msalConfig; // will be invoked later when creating msalservice
}

export function MSALAngularConfigFactory() {
  return {
    consentScopes: [
      "user.read",
      "openid",
      "profile"
    ],
    extraQueryParameters: {}
  };
}

export function initializeApp(appconfig: AppConfig) {

  var envConfig = appconfig.load();

  msalConfig = {
    auth: {
      clientId: envConfig.clientId,
      authority: `https://login.microsoftonline.com/${envConfig.tenant}`,
      validateAuthority: true,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'localStorage', // Use 'localStorage' for MSAL Angular v1.x and Angular 7
      storeAuthStateInCookie: true   // Recommended for IE11/Edge or incognito
    },
    system: {
      logger: new Logger(
        (logLevel, message, pii) => { if (logLevel <= LogLevel.Info) console.log('[MSAL]', message); },
        { level: LogLevel.Info, piiLoggingEnabled: false }
      )
    }
  };

      return () => msalConfig;
};


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SignOutComponent,
    SidebarComponent,
    FooterComponent,
    LoaderComponent,
    HomeComponent,
    PrivacyComponent,
    TermsOfUseComponent
  ],
  imports: [
    routes,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    GridModule,
    SharedModule,
    MsalModule,
    UserIdleModule.forRoot({idle: 3600, timeout: 3600, ping: 3600})
  ],
  exports:[
    LoaderComponent,
    SignOutComponent
  ],

  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true
    }, 
    {
      provide: MSAL_CONFIG,
      useFactory: msalConfigFactory,
      deps: []
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: MSALAngularConfigFactory
    },
    MsalService,
    HttpClient,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true, }

,AuthenticationService,AuthGuard,LoaderService],
    
  bootstrap: [AppComponent]
})
export class AppModule { }
